// extracted by mini-css-extract-plugin
export default {"parameter":"WGCRh","selected":"kAXwE","noPopover":"YRyWQ","DashboardNight":"VjHPj","ThemeNight":"BaPVQ","name":"BYKPY dPTrR"};